<template>
  <div class="pickCompany">
    <PlateTitle title="担保公司">
      <template
        slot="subtitle"
        v-if="companyList.length>1"
      >
        <span class="subtitle"><a-icon
          type="exclamation-circle"
          theme="filled"
        />请选择担保公司</span>
      </template>
    </PlateTitle>
    <ul class="main">
      <li
        v-for="(item,index) in companyList"
        :key="item.name"
        :class="['item',index===currentIndex?'active':'']"
        :title="item.name"
        @click="pickChange(item,index)"
      >
        <div class="logo">
          <img
            :src="item.logoUrl"
            :alt="item.name+'Logo'"
          >
        </div>
        <div class="name">
          {{ item.name }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Icon } from 'ant-design-vue';
import PlateTitle from '@/components/PlateTitle';
import { guaranteeCompanyList } from '@/config';

export default {
  name: 'PickCompany',
  components: {
    PlateTitle,
    aIcon: Icon,
  },
  props: {
    defaultValue: {
      type: String,
      default: '',
    },
    onlyValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    companyList() {
      const onlyValue = this.onlyValue;

      let result;
      if (!onlyValue) {
        result = guaranteeCompanyList;
      } else {
        result = guaranteeCompanyList.filter(item => {
          return item.code === onlyValue;
        });
      }

      return result;
    },
  },
  mounted() {

    if (this.defaultValue) {
      const currentIndex = this.companyList.findIndex(item => {
        return item.code === this.defaultValue;
      });

      this.currentIndex = currentIndex;
    }

    this.$emit('change', this.companyList[this.currentIndex].code);
  },
  methods: {
    pickChange(item, index) {
      this.currentIndex = index;
      this.$emit('change', item.code);
    },
  },
};
</script>

<style lang="less" scoped>
.subtitle{
  color:#BDA266;
  font-size: 14px;
  i{
    margin-right: 5px;
    color:#FFBE2C
  }
}
.main{
  margin-top: 20px;
  overflow: hidden;
  list-style-type: none;
  padding: 0;
  .item{
    position: relative;
    float: left;
    width: 210px;
    margin:0 40px 20px 0;
    cursor: pointer;
    &.active{
      .logo{
        border-color:#007CE2;
      }
      &::after{
        position: absolute;
        right:0;
        top:0;
        display: block;
        content:' ';
        background:url('./../../../assets/image/block-tick.png') no-repeat center center;
        background-size: 100% 100%;
        width: 24px;
        height: 24px;
      }
    }
    &:nth-child(4n){
      margin-right: 0;
    }
    .logo{
      width: 100%;
      padding:35px 0;
      border: 1px solid #DFDFDF;
      border-radius: 4px;
      box-sizing: border-box;
      img{
        display: block;
        margin: 0 auto;
        height: 30px;
      }
    }
    .name{
      margin-top: 17px;
      width: 210px;
      font-size: 14px;
      color: #666;
      text-align: center;
      height: 45px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
